import { SelectUi } from "../../ui";
import { useEstadosperiodocontable } from "../../../actions";

export const EstadoPeriodosContableSelect = ({ ...others }) => {
  const { data, isLoading } = useEstadosperiodocontable();
  return <SelectUi data={data} loading={isLoading} {...others} />;
};
